<template>
    <div>
        <template v-if="loading">
            <div class="spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </template>
        <div v-else class="form-group radio-group">
            <div v-for="option in options"
                :key="option.id"
                class="btn-group-toggle px-0 mb-1 col">
                <label class="container-radio container-radio-sm d-flex align-items-center my-2">
                    <input v-on:input="onUpdate(option)"
                        :checked="option.id == currentValue"
                        :id="getInputKey(option)"
                        :name="getInputKey()"
                        class="form-control"
                        type="radio"
                        :required="!!required">
                    <span class="checkmark mr-3"></span>
                    {{ option.name }}
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import UtilsMixin from '../UtilsMixin';
import feather from 'feather-icons';

export default {
    data() {
        return {
            randomInputKey: Math.floor(Math.random() * 1000000),
            options: {},
            loading: true,
        }
    },

    props: ['value', 'label', 'config'],

    mixins: [UtilsMixin],

    created() {

        return this.api.getData(`/${this.ref_api}/_ref_`, {}).then((res) => {
            this.options = _.get(res, 'data', []);
            this.loading = true;


        }).then(() => {
            this.loading = false;
            this.$nextTick(() => {
                feather.replace();
            });
        });
    },

    mounted() {

    },

    computed: {

        ref_api(){
            return _.get(this.config, 'ref_api', 'utilities');
        },

        description() {
            return _.get(this.config, 'description', '');
        },

        defaultValue() {
            return _.get(this.config, 'default');
        },

        currentValue() {
            return this.value || _.get(this.config, 'default');
        },

        refKey() {
            return _.get(this.config, 'ref_key', 'name');
        },

        required() {
            return _.get(this.config, 'required', false);
        },
    },

    methods: {
        onUpdate(value) {
            this.$emit('input', value[this.refKey]);
        },

        getInputKey(value = null) {
            const suffix = value ? `-${value.id}` : '';
            return `-radio-${this.randomInputKey}${suffix}`;
        },
    }
}
</script>
